import { AuthApi } from '@/features/api/services/authApi.js'
import {
  getConnectMobileProfileResponseValue,
  isConnectMobileProfileSuccess,
} from '@/features/auth/utils/connectMobileProfileResponse.js'
import {
  formatInvitationCodeForApi,
  formatInvitationCodeInput,
  isInvitationCodeComplete,
} from '@/features/auth/utils/invitationCodeFormat.js'
import { useAuthStore } from '@/features/auth/useAuthStore.js'

const CONNECT_INVITATION_ERROR_I18N_KEYS = {
  You_Already_Added_This_Tenant: 'clubSelector.invitationErrors.alreadyAdded',
  Selected_Profile_Already_Connected_To_Other_Mobile_User:
    'clubSelector.invitationErrors.profileConnected',
}

export function resolveConnectInvitationErrorI18nKey(responseValue) {
  if (!responseValue) {
    return 'clubSelector.invitationErrors.generic'
  }

  return (
    CONNECT_INVITATION_ERROR_I18N_KEYS[responseValue] || 'clubSelector.invitationErrors.generic'
  )
}

export async function connectInvitationForAuthenticatedUser(invitationCode) {
  const normalizedCode = formatInvitationCodeInput(invitationCode)

  if (!isInvitationCodeComplete(normalizedCode)) {
    return {
      success: false,
      reason: 'incompleteCode',
    }
  }

  const response = await AuthApi.connectMobileProfile({
    invitationCode: formatInvitationCodeForApi(normalizedCode),
  })

  if (isConnectMobileProfileSuccess(response)) {
    const authStore = useAuthStore()
    await authStore.getMyDetailsWithoutCache(false)

    return {
      success: true,
      response,
    }
  }

  const responseValue = getConnectMobileProfileResponseValue(response)

  return {
    success: false,
    response,
    responseValue,
    i18nKey: resolveConnectInvitationErrorI18nKey(responseValue),
  }
}
